<template>
  <div>
    <div class="row">
      <div class="col-lg-8 inline">
        <h2 style="display: inline">Attendance Report</h2>
      </div>
      <div class="col-lg-4 block">
        <span class="demonstration">Select Date Range :</span>
        <el-date-picker
          label=""
          v-model="value2"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          @change="getDate()"
        ></el-date-picker>
      </div>

      <div class="col-lg">
        <h4>
          Select Department :
          <el-select
            class="select-info tab select-width"
            placeholder="Select Department"
            v-model="selects.selectDept"
            :disabled="disableDept"
            @change="getDepartment()"
          >
            <el-option
              v-for="option in selects.department"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-lg">
        <h4>
          Select Area :
          <el-select
            class="select-info tab select-width"
            placeholder="Select Service Area"
            v-model="selects.selectArea"
            :disabled="disableArea"
            @change="getArea()"
          >
            <el-option
              v-for="option in selects.area"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-lg">
        <h4>
          Select Position :
          <el-select
            class="select-info tab select-width"
            placeholder="Select Position"
            v-model="selects.selectPos"
            :disabled="disablePosition"
            @change="getPosition()"
          >
            <el-option
              v-for="option in selects.position"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-lg">
        <h4>
          Select Employee :
          <el-select
            class="select-info tab select-width"
            placeholder="Select Employee"
            v-model="selects.selectEmp"
            :disabled="disableEmployee"
            @change="getEmployee()"
          >
            <el-option
              v-for="option in selects.employee"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>
      <div class="col-lg-12">
        <hr />
      </div>
      <div class="col-md-12">
        <card card-body-classes="table-full-width">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <base-input label="rows visible">
                <el-select
                  class="select-info mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input>
            </div>
            <el-table
              :data="queriedData"
              :header-cell-style="{
                background: 'transparent',
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
              :cell-style="{
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
            >
              <el-table-column
                sortable
                :min-width="80"
                prop="Date"
                label="Date"
              ></el-table-column>
              <el-table-column
                sortable
                :min-width="80"
                prop="Day"
                label="Day"
              ></el-table-column>
              <el-table-column
                sortable
                :min-width="100"
                prop="EmpID"
                label="Employee ID"
              ></el-table-column>
              <el-table-column
                sortable
                :min-width="160"
                prop="Name"
                label="Name"
              ></el-table-column>
              <!-- <el-table-column sortable :min-widh="150" prop="LastName" label="Last Name"></el-table-column> -->
              <el-table-column
                sortable
                :min-width="80"
                prop="TimeIn"
                label="In"
              ></el-table-column>
              <el-table-column
                sortable
                :min-width="80"
                prop="TimeOut"
                label="Out"
              ></el-table-column>
              <el-table-column
                sortable
                :min-width="100"
                prop="WorkTime"
                label="Work Time"
              ></el-table-column>
              <el-table-column
                sortable
                :min-width="130"
                prop="WorkHours"
                label="Working Hours"
              ></el-table-column>
              <el-table-column
                sortable
                :min-width="80"
                prop="Status"
                label="Status"
              ></el-table-column>
              <el-table-column
                sortable
                :min-width="80"
                prop="TimeLate"
                label="Time Late"
              ></el-table-column>

              <el-table-column
                sortable
                :min-width="90"
                prop="Remarks"
                label="Remarks"
              ></el-table-column>
            </el-table>
            <div class="d-flex justify-content-center spinner" v-if="display">
              <circle-8></circle-8>
            </div>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
    <div class="col-lg-12 text-right">
      <base-button type="primary" @click="exportCSV(tableData)"
        >Export to CSV</base-button
      >
    </div>
  </div>
</template>
<script>
import LineChart from "src/components/Charts/LineChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import { BaseProgress, BasePagination } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import Fuse from "fuse.js";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    LineChart,
    BaseProgress,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Loading,
    Circle8,
  },
  data() {
    return {
      selects: {
        selectTime: "",
        selectDept: "",
        selectArea: "",
        selectPos: "",
        selectEmp: "",
        time: [
          {
            value: "Today",
            label: "Yesterday",
          },
          {
            value: "Daily",
            label: "Daily",
          },
          {
            value: "Weekly",
            label: "Weekly",
          },
          {
            value: "Monthly",
            label: "Monthly",
          },
          {
            value: "Yearly",
            label: "Yearly",
          },
        ],
        department: [],
        area: [],
        employee: [],
        position: [],
      },
      // date range
      startdate: "",
      enddate: "",
      // disable
      disableDept: true,
      disableArea: true,
      disablePosition: true,
      disableEmployee: true,
      // loading
      display: false,
      searchQuery: "",
      propsToSearch: ["EmpID", "Name", "Status"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      // currentRow: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      value2: null,
      // created for filter purpose
      tempDepartment: [],
      tempArea: [],
      tempPosition: [],
      tempEmployee: [],
    };
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      console.log(this.searchedData);
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      console.log(result);
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  mounted() {},
  methods: {
    callData() {
      this.searchQuery = "";
      this.selects.department = [];
      this.selects.area = [];
      this.selects.position = [];
      this.selects.employee = [];
      this.tableData = [];
      this.tempDepartment = [];
      this.searchedData = [];
      this.selects.selectDept = "";
      this.selects.selectArea = "";
      this.selects.selectPos = "";
      this.selects.selectEmp = "";

      // let startdate = ""
      // let enddate = ""

      // if(this.selects.selectTime == "Today"){
      //   startdate = moment().unix()
      //   enddate = moment().unix()
      // } else if (this.selects.selectTime == "Daily"){
      //   startdate = moment().startOf('isoWeek').unix()
      //   enddate = moment().unix()
      // } else if (this.selects.selectTime == "Weekly"){
      //   startdate = moment().startOf('month').unix()
      //   enddate = moment().unix()
      // } else if (this.selects.selectTime == "Monthly"){
      //   startdate = moment().startOf('year').unix()
      //   enddate = moment().unix()
      // } else {
      //   startdate = moment('2020').startOf('year').unix()
      //   enddate = moment().unix()
      // }
      console.log(this.startdate, this.enddate);
      console.log(`:9995/api/v1/report/log/${this.startdate}/${this.enddate}`);

      // call
      this.display = true;
      this.$http
        .get(":9995/api/v1/report/log/" + this.startdate + "/" + this.enddate)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            let filter = [];
            for (var i = 0; i < response.length; i++) {
              let timein = moment(response[i].TimeIn).format("HH:mm:ss");
              let timeout = moment(response[i].TimeOut).format("HH:mm:ss");
              if (timein == "Invalid date") {
                timein = "-";
              }
              if (timeout == "Invalid date") {
                timeout = "-";
              }

              let workhour = response[i].TotalHours;
              if (workhour == "") {
                workhour = "-";
              }

              let obj = {
                Date: moment(response[i].Date).format("YYYY-MM-DD"),
                Day: moment(response[i].Date).format("ddd"),
                EmpID: response[i].EmpID,
                Name: response[i].Name,
                // LastName: response[i].
                TimeIn: timein,
                TimeOut: timeout,
                WorkTime: response[i].WorkingHours,
                WorkHours: workhour,
                Status: response[i].Status,
                Remarks: response[i].Remarks,
                DeptName: response[i].DeptName,
                ServiceAreaName: response[i].ServiceAreaName,
                Position: response[i].Position,
                TimeLate: response[i].TimeLate,
              };
              this.tableData.push(obj);
              this.tempDepartment.push(obj);
              this.searchedData.push(obj);
              filter.push(response[i].DeptName);
            }

            // department filter
            let all = {
              value: "All",
              label: "All",
            };
            this.selects.department.push(all);
            let temp = [];
            for (var i = 0; i < filter.length; i++) {
              if (temp.indexOf(filter[i]) === -1) {
                temp.push(filter[i]);
              }
            }

            for (i = 0; i < temp.length; i++) {
              let obj = {
                value: temp[i],
                label: temp[i],
              };
              this.selects.department.push(obj);
            }
            this.disableDept = false;
            this.display = false;
          } else {
            swal({
              title: "Opps! something went wrong",
              text: res.message,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.display = false;
          }
        });
    },
    getDate() {
      this.searchQuery = "";
      this.selects.selectTime = "";
      this.startdate = moment(this.value2[0]).unix();
      this.enddate = moment(this.value2[1]).unix();
      console.log(this.startdate, this.enddate);
      this.tableData = [];
      this.tempDepartment = [];
      this.searchedData = [];
      this.selects.selectDept = "";
      this.selects.selectArea = "";
      this.selects.selectPos = "";
      this.selects.selectEmp = "";

      // call
      this.display = true;
      this.callData();
      // this.$http.get(":9995/api/v1/report/log/" + startdate + "/" + enddate)
      //   .then(res=> {
      //     if(!res.error){
      //       let response = res.message
      //       console.log(response)
      //       for(var i=0; i<response.length; i++){
      //         let timein = moment(response[i].TimeIn).format("HH:mm:ss")
      //         let timeout = moment(response[i].TimeOut).format("HH:mm:ss")
      //         if(timein == "Invalid date"){
      //           timein = "-"
      //         }
      //         if(timeout == "Invalid date"){
      //           timeout = "-"
      //         }
      //         let obj = {
      //           Date: moment(response[i].Date).format("YYYY-MM-DD"),
      //           Day: moment(response[i].Date).format("ddd"),
      //           EmpID: response[i].EmpID,
      //           Name: response[i].Name,
      //           // LastName: response[i].
      //           TimeIn: timein,
      //           TimeOut: timeout,
      //           WorkTime: response[i].WorkingHours,
      //           WorkHours: response[i].TotalHours,
      //           Status: response[i].Status,
      //           Remarks: response[i].Remarks,
      //           DeptName: response[i].DeptName,
      //           ServiceAreaName: response[i].ServiceAreaName,
      //           Position: response[i].Position,
      //         }
      //         this.tableData.push(obj)
      //         this.tempDepartment.push(obj)
      //         this.searchedData.push(obj)
      //       }
      //       this.display = false
      //     }
      //   })
    },
    getDepartment() {
      this.searchQuery = "";
      console.log(this.selects.selectDept);
      console.log(this.tempDepartment);
      this.selects.area = [];
      this.selects.position = [];
      this.selects.employee = [];
      this.selects.selectPos = "";
      this.selects.selectEmp = "";
      this.selects.selectArea = "";
      this.tableData = [];
      this.tempArea = [];
      this.searchedData = [];
      let filter = [];
      for (var i = 0; i < this.tempDepartment.length; i++) {
        if (this.selects.selectDept == this.tempDepartment[i].DeptName) {
          let obj = {
            Date: moment(this.tempDepartment[i].Date).format("YYYY-MM-DD"),
            Day: moment(this.tempDepartment[i].Date).format("ddd"),
            EmpID: this.tempDepartment[i].EmpID,
            Name: this.tempDepartment[i].Name,
            // LastName: response[i].
            TimeIn: this.tempDepartment[i].TimeIn,
            TimeOut: this.tempDepartment[i].TimeOut,
            WorkTime: this.tempDepartment[i].WorkTime,
            WorkHours: this.tempDepartment[i].WorkHours,
            Status: this.tempDepartment[i].Status,
            Remarks: this.tempDepartment[i].Remarks,
            DeptName: this.tempDepartment[i].DeptName,
            ServiceAreaName: this.tempDepartment[i].ServiceAreaName,
            Position: this.tempDepartment[i].Position,
            TimeLate: this.tempDepartment[i].TimeLate,
          };
          this.tableData.push(obj);
          this.tempArea.push(obj);
          this.searchedData.push(obj);
          filter.push(this.tempDepartment[i].ServiceAreaName);
        }

        if (this.selects.selectDept == "All") {
          this.tableData = this.tempDepartment;
          this.tempArea = this.tempDepartment;
          this.searchedData = this.tempDepartment;
          filter.push(this.tempDepartment[i].ServiceAreaName);
        }
      }
      console.log(this.tableData);
      console.log(filter);

      let all = {
        value: "All",
        label: "All",
      };
      this.selects.area.push(all);

      let temp = [];
      for (var i = 0; i < filter.length; i++) {
        if (temp.indexOf(filter[i]) == -1) {
          temp.push(filter[i]);
        }
      }
      console.log(temp);
      for (var i = 0; i < temp.length; i++) {
        let obj = {
          value: temp[i],
          label: temp[i],
        };
        this.selects.area.push(obj);
      }
      this.disableArea = false;
    },
    getArea() {
      this.searchQuery = "";
      console.log(this.selects.selectArea);
      console.log(this.tempArea);
      this.selects.position = [];
      this.selects.employee = [];
      this.selects.selectPos = "";
      this.selects.selectEmp = "";
      this.tableData = [];
      this.tempPosition = [];
      this.searchedData = [];
      let filter = [];
      for (var i = 0; i < this.tempArea.length; i++) {
        if (this.selects.selectArea == this.tempArea[i].ServiceAreaName) {
          let obj = {
            Date: moment(this.tempArea[i].Date).format("YYYY-MM-DD"),
            Day: moment(this.tempArea[i].Date).format("ddd"),
            EmpID: this.tempArea[i].EmpID,
            Name: this.tempArea[i].Name,
            // LastName: response[i].
            TimeIn: this.tempArea[i].TimeIn,
            TimeOut: this.tempArea[i].TimeOut,
            WorkTime: this.tempArea[i].WorkTime,
            WorkHours: this.tempArea[i].WorkHours,
            Status: this.tempArea[i].Status,
            Remarks: this.tempArea[i].Remarks,
            DeptName: this.tempArea[i].DeptName,
            ServiceAreaName: this.tempArea[i].ServiceAreaName,
            Position: this.tempArea[i].Position,
            TimeLate: this.tempArea[i].TimeLate,
          };
          this.tableData.push(obj);
          this.tempPosition.push(obj);
          this.searchedData.push(obj);
          filter.push(this.tempArea[i].Position);
        }

        if (this.selects.selectArea == "All") {
          this.tableData = this.tempArea;
          this.tempPosition = this.tempArea;
          this.searchedData = this.tempArea;
          filter.push(this.tempArea[i].Position);
        }
      }
      let temp = [];
      let all = {
        value: "All",
        label: "All",
      };
      this.selects.position.push(all);
      for (var i = 0; i < filter.length; i++) {
        if (temp.indexOf(filter[i]) == -1) {
          temp.push(filter[i]);
        }
      }
      for (var i = 0; i < temp.length; i++) {
        let obj = {
          value: temp[i],
          label: temp[i],
        };
        this.selects.position.push(obj);
      }
      this.disablePosition = false;
    },
    getPosition() {
      this.searchQuery = "";
      console.log(this.selects.selectPos);
      console.log(this.tempPosition);
      this.selects.employee = [];
      this.selects.selectEmp = "";
      this.tableData = [];
      this.tempEmployee = [];
      this.searchedData = [];
      let filter = [];
      for (var i = 0; i < this.tempPosition.length; i++) {
        console.log(this.tempPosition[i].Position);
        if (this.selects.selectPos == this.tempPosition[i].Position) {
          let obj = {
            Date: moment(this.tempPosition[i].Date).format("YYYY-MM-DD"),
            Day: moment(this.tempPosition[i].Date).format("ddd"),
            EmpID: this.tempPosition[i].EmpID,
            Name: this.tempPosition[i].Name,
            // LastName: response[i].
            TimeIn: this.tempPosition[i].TimeIn,
            TimeOut: this.tempPosition[i].TimeOut,
            WorkTime: this.tempPosition[i].WorkTime,
            WorkHours: this.tempPosition[i].WorkHours,
            Status: this.tempPosition[i].Status,
            Remarks: this.tempPosition[i].Remarks,
            DeptName: this.tempPosition[i].DeptName,
            ServiceAreaName: this.tempPosition[i].ServiceAreaName,
            Position: this.tempPosition[i].Position,
            TimeLate: this.tempPosition[i].TimeLate,
          };
          this.tableData.push(obj);
          this.tempEmployee.push(obj);
          this.searchedData.push(obj);
          filter.push(this.tempPosition[i].Name);
        }

        if (this.selects.selectPos == "All") {
          this.tableData = this.tempPosition;
          this.tempEmployee = this.tempPosition;
          this.searchedData = this.tempPosition;
          filter.push(this.tempPosition[i].Name);
        }
      }
      let temp = [];
      let all = {
        value: "All",
        label: "All",
      };
      this.selects.employee.push(all);
      for (var i = 0; i < filter.length; i++) {
        if (temp.indexOf(filter[i]) == -1) {
          temp.push(filter[i]);
        }
      }
      console.log(temp);
      for (var i = 0; i < temp.length; i++) {
        let obj = {
          value: temp[i],
          label: temp[i],
        };
        this.selects.employee.push(obj);
      }
      this.disableEmployee = false;
    },
    getEmployee() {
      this.searchQuery = "";
      console.log(this.selects.selectEmp);
      console.log(this.tempEmployee);
      this.tableData = [];
      this.searchedData = [];
      for (var i = 0; i < this.tempEmployee.length; i++) {
        console.log(this.tempEmployee[i].Position);
        if (this.selects.selectEmp == this.tempEmployee[i].Name) {
          let obj = {
            Date: moment(this.tempEmployee[i].Date).format("YYYY-MM-DD"),
            Day: moment(this.tempEmployee[i].Date).format("ddd"),
            EmpID: this.tempEmployee[i].EmpID,
            Name: this.tempEmployee[i].Name,
            // LastName: response[i].
            TimeIn: this.tempEmployee[i].TimeIn,
            TimeOut: this.tempEmployee[i].TimeOut,
            WorkTime: this.tempEmployee[i].WorkTime,
            WorkHours: this.tempEmployee[i].WorkHours,
            Status: this.tempEmployee[i].Status,
            Remarks: this.tempEmployee[i].Remarks,
            DeptName: this.tempEmployee[i].DeptName,
            ServiceAreaName: this.tempEmployee[i].ServiceAreaName,
            Position: this.tempEmployee[i].Position,
            TimeLate: this.tempEmployee[i].TimeLate,
          };
          this.tableData.push(obj);
          this.searchedData.push(obj);
        }

        if (this.selects.selectEmp == "All") {
          this.tableData = this.tempEmployee;
          this.searchedData = this.tempEmployee;
        }
      }
    },
    exportCSV(attendancereport) {
      console.log(attendancereport);
      let csvData = this.$CSV(this.tableData);
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "AttendanceReport.csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
  created() {
    // this.selects.selectTime =  this.selects.time[0].value

    // today date (by default)
    this.startdate = moment().subtract(1, "days").unix();
    this.enddate = moment().subtract(1, "days").unix();
    this.callData();
  },

  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      console.log(value);
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["EmpID", "Name", "Status"],
        threshold: 0.6,
      });

      console.log("CURR_TABLEDATA", this.tableData);
      let result = this.tableData;
      console.log(result);
      // console.log(this.searchQuery)
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      console.log("DATA_RESULT:", result);
      this.searchedData = result;
      console.log("DATA_SEARCH:", this.searchedData);
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 105%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.test {
  width: 800px;
}
.dialog {
  margin-left: 30%;
}
</style>
